module.exports = __webpack_public_path__ + "static/media/giphy01.1fc539d5.mp4";